import { mapGetters, mapState } from "vuex";
import { getToken } from "@/utils/cache";
export default {
  computed: {
    ...mapState("user", ["person_id", "isFree"]),
    ...mapGetters("level", {
      // 当前激活等级对象信息
      currentLevelActive: "levelActiveObj",
    }),
    peopleId() {
      if (getToken()) {
        return this.person_id;
      } else {
        return undefined;
      }
    },
    unlimited() {
      if (getToken()) {
        return this.isFree;
      } else {
        return undefined;
      }
    },
  },
};
